module.exports = "<span class=\"dropdown__button dropdown__button--{{type}}\" (click)=\"toggle($event)\"> <ng-content></ng-content>&nbsp; <i class=\"dropdown__chevron\">" + require('icons/chevron.svg') + "</i> </span> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dropdown/dropdown-button.component.html
// module id = ./src/app/shared/components/dropdown/dropdown-button.component.html
// module chunks = 21